import { Component, Vue } from 'vue-property-decorator';
import { DeliverableOrderTypes as DeliverableOrderTypesEnum } from '@/enums/DeliverableOrderTypes';
@Component
export default class DeliverableOrderType extends Vue {
  get deliverableOrderTypes() {
    return [
      { text: this.$t('deliverableOrderTypes.foodspot'), value: DeliverableOrderTypesEnum.FOODSPOT },
      { text: this.$t('deliverableOrderTypes.delivery'), value: DeliverableOrderTypesEnum.DELIVERY },
    ].sort((a, b) => {
      const textA = String(a.text).toLowerCase();
      const textB = String(b.text).toLowerCase();
      return textA.localeCompare(textB);
    });
  }
}
